var React = require('react');

function VideoPlay (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-828 -691)"},[React.createElement("g",{"transform":"translate(828 691)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0},[React.createElement("circle",{"cx":"132.5","cy":"132.5","r":"132.5","stroke":"none","key":0}),React.createElement("circle",{"cx":"132.5","cy":"132.5","r":"131.5","fill":"none","key":1})]),React.createElement("path",{"d":"M18,0,36,18H0Z","transform":"translate(970 806) rotate(90)","fill":"#fff","key":1})]));
}

VideoPlay.defaultProps = {"width":"265","height":"265","viewBox":"0 0 265 265"};

module.exports = VideoPlay;

VideoPlay.default = VideoPlay;
